import {
  initializeIntersectionObserver, onMouseOut, onMouseOver, resetStyles,
} from '@scripts/frontend/shared/list-gallery.shared';
import { isTouchDevice } from '@scripts/frontend/utilities';

const listGallerySelector = '.list-gallery-values';

const mouseHoverEventListener = (listGallery, items) => {
  const imgContainer = listGallery.querySelector('.list-gallery__bg-image--value');
  imgContainer.style.backgroundImage = '';
  [...items].forEach((link) => {
    const arrow = link.querySelector('.list-gallery__item-arrow--value');
    const svg = link.querySelector('.list-gallery__item-logo--value');
    const title = link.querySelector('.list-gallery__item-title--value');
    const src = link.getAttribute('data-image');
    const text = link.querySelector('.list-gallery__item-text--value');

    link.addEventListener('mouseover', () => onMouseOver(imgContainer, arrow, svg, title, src, text));
    link.addEventListener('mouseout', () => onMouseOut(imgContainer, arrow, svg, title, src, text));

    if ((isTouchDevice() || !window.matchMedia('(min-width: 1024px)').matches)) {
      resetStyles(imgContainer, arrow, svg, title, src, text);
    }
  });
};

const initializeListGallery = () => {
  const listGallery = document.querySelector(listGallerySelector);
  const items = listGallery ? listGallery.querySelectorAll('.list-gallery__item--value') : null;
  const imgContainer = listGallery ? listGallery.querySelector('.list-gallery__bg-image--value') : null;
  const mainContainer = listGallery ? listGallery.querySelector('.list-gallery__container--value') : null;

  if (listGallery) {
    initializeIntersectionObserver(mainContainer, imgContainer);
    const resizeObserver = new ResizeObserver(() => {
      mouseHoverEventListener(listGallery, items);
    });

    resizeObserver.observe(document.body);
  }
};

/**
 * Javascript to run immediately on page load
 */
window.addEventListener('load', initializeListGallery, false);
